import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from 'dpl/common/components/Icon';

export default function FilterDrawer({
  className,
  children,
  iconSize,
  title,
  onDrawerOpen,
  onDrawerClose,
  tag
}) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    return isOpen ? onDrawerOpen() : onDrawerClose();
  }, [isOpen]);

  return (
    <div className={classnames('FilterDrawer', className)}>
      <ul>
        <li className="FilterDrawerItem mh4 mh0-md bb b--light-gray">
          <button
            type="button"
            className="flex items-center justify-between w-100 pv4"
            onClick={() => setIsOpen(!isOpen)}
          >
            <div className="flex">
              <p className="fw-medium flex-auto">{title}</p>
              {tag && (
                <span className="f2 green bg-washed-green ph2 pv1 ml2 br2 fw-medium min-content-h self-center">
                  {tag}
                </span>
              )}
            </div>
            <Icon
              name={`fat-arrow-${isOpen ? 'down' : 'right'}`}
              height={iconSize}
              width={iconSize}
            />
          </button>
          {isOpen ? <div className="pb4">{children}</div> : null}
        </li>
      </ul>
    </div>
  );
}

FilterDrawer.propTypes = {
  className: PropTypes.string,
  iconSize: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  onDrawerOpen: PropTypes.func,
  onDrawerClose: PropTypes.func,
  tag: PropTypes.string
};

FilterDrawer.defaultProps = {
  className: '',
  iconSize: '24px',
  title: '',
  onDrawerOpen: () => {},
  onDrawerClose: () => {},
  tag: null
};
